import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormModel, DynamicFormService } from '@ng-dynamic-forms/core';
import { Store } from '@ngrx/store';
import { ActiveCartService, StateWithMultiCart } from '@spartacus/cart/base/core';
import {
  AuthService,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  UserIdService,
} from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { ComponentService } from 'src/app/service/component.service';
import { GoogleTagManagerService } from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { OrderHistoryService } from '../../../../service/orders/order-history.service';

@Component({
  selector: 'app-backorder-cart-modal',
  templateUrl: './backorder-cart-modal.component.html',
  styleUrls: ['./backorder-cart-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BackorderCartModalComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  formModel: DynamicFormModel;
  cartId: string;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  saveCartDetailsFormModelSubscription$: Subscription;
  saveCartDetailsFormGroupSubscription$: Subscription;
  activeLanguage$: Observable<string> = this.languageService.getActive();

  backorderEntries: any;
  formEntries: any;
  pageType: string;
  addToCartInprogressModal = false;

  public filteredEntries: any;
  private modalEntries: any;
  private increment: boolean;
  private updatedQuantityAdded: number;
  private cart: any;
  private findQty: any;
  private quantity: any;
  private dateFormatted: any;
  nonBackorder: any;

  constructor(
    protected cartService: ActiveCartService,
    // private cartService: CartExtendService,
    private formService: DynamicFormService,
    protected cmsService: CmsService,
    private routing: RoutingService,
    protected store: Store<StateWithMultiCart>,
    private auth: AuthService,
    private messageService: GlobalMessageService,
    private componentService: ComponentService,
    private gtmService: GoogleTagManagerService,
    private languageService: ShimanoLanguageService,
    private userIdService: UserIdService,
    private orderHistoryService: OrderHistoryService,
    private baseStoreService: BaseStoreService,
    private cd: ChangeDetectorRef,
    protected modalService: StandardModalService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.backorderEntries = res.backorderEntries;
        this.formEntries = res.formEntries;
        this.pageType = res.type ? res.type : res.pageType;
      });
  }

  ngOnInit() {
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '-');
      });
    this.backorderEntries.inventoryBackorderList = this.backorderEntries.inventoryBackorderList.map((item: any) => {
      return { ...item, checkBox: true };
    });
    this.checkboxUpdate();
  }
  checkboxUpdate() {
    this.filteredEntries = this.backorderEntries.inventoryBackorderList.filter(
      (entry: { checkBox: any }) => entry.checkBox === true
    );
    if (this.backorderEntries?.inventoryBackorderList.length > 0) {
      if (typeof this.formEntries !== 'undefined') {
        // Check the entries for property productCode which comes from order form
        if (this.formEntries[0]?.hasOwnProperty('productCode')) {
          // Order Form entry adding logic
          this.nonBackorder = this?.formEntries?.filter(
            (entry: any) =>
              !this.backorderEntries.inventoryBackorderList.find((item: any) => entry?.productCode === item?.productId)
          );
        } else {
          // Quick order cart adding logic
          this.nonBackorder = this?.formEntries?.filter(
            (entry: any) =>
              !this.backorderEntries.inventoryBackorderList.find((item: any) => entry?.code === item?.productId)
          );
        }
      }
    }
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  saveBackorder() {
    if (!this.addToCartInprogressModal) {
      this.addToCartInprogressModal = true;

      this.filteredEntries = this.backorderEntries.inventoryBackorderList.filter(
        (entry: { checkBox: any }) => entry?.checkBox === true
      );

      this.cartService
        .getActiveCartId()
        .pipe(map((data) => data))
        .subscribe((results) => {
          this.cartId = results;
        })
        .unsubscribe();

      this.componentService.setMiniCartLoading(true);
      this.cd.detectChanges();

      // Filtering the selected entries depending on checkbox selection
      this.filteredEntries.forEach((item: { quantity: number; productId: any }) => {
        // non orderForm inputs
        if (this?.formEntries?.orderEntries) {
          this.findQty = this.formEntries.orderEntries.find((obj: any) => {
            return obj.product.code === item.productId;
          });
        } else {
          if (this.formEntries[0]?.hasOwnProperty('code')) {
            this.findQty = this?.formEntries.find((obj: any) => {
              return obj.code === item.productId;
            });
          } else {
            this.findQty = this?.formEntries.find((obj: any) => {
              return obj.productCode === item.productId;
            });
          }
        }
        if (this?.findQty?.quantity) {
          this.quantity = this?.findQty.quantity;
        } else {
          this.quantity = this?.findQty.qty;
        }
        if (!item.productId || this.quantity <= 0) {
          return;
        }
        this.addToCart(item.productId, this.quantity);
      });
      // non backorder entries
      if (this.backorderEntries?.inventoryBackorderList.length > 0) {
        if (typeof this.formEntries !== 'undefined') {
          // Check the entries for property productCode which comes from order form
          if (this.formEntries[0]?.hasOwnProperty('productCode')) {
            // Order Form entry adding logic
            this.nonBackorder = this?.formEntries?.filter(
              (entry: any) =>
                !this.backorderEntries.inventoryBackorderList.find(
                  (item: any) => entry?.productCode === item?.productId
                )
            );

            if (this.nonBackorder.length > 0) {
              this.nonBackorder.forEach((item: any) => {
                this.addToCart(item.productCode, item.quantity);
              });
            }
          } else {
            // Quick order cart adding logic
            this.nonBackorder = this?.formEntries?.filter(
              (entry: any) =>
                !this.backorderEntries.inventoryBackorderList.find((item: any) => entry?.code === item?.productId)
            );
            if (this.nonBackorder.length > 0) {
              this.nonBackorder.forEach((item: any) => {
                this.addToCart(item.code, item.qty);
              });
            }
          }
        }
      }
    }
  }

  addToCart(productCode: any, quantity: number) {
    this.componentService.setMiniCartLoading(true);
    this.cd.detectChanges();
    if (!productCode || quantity <= 0) {
      return;
    }
    this.cartService
      .getEntry(productCode)
      .subscribe(
        (entry) => {
          if (entry) {
            this.increment = true;
            if (entry.product.stock.stockLevel < entry.quantity + quantity) {
              this.updatedQuantityAdded = entry.product.stock.stockLevel - entry.quantity;
            }
          }
          this.cartService.addEntry(productCode, quantity);
          this.increment = false;
          this.cart = this.cartService.isStable();
          const cartStatus = this.cart.subscribe((cart: any) => {
            if (cart) {
              this.addToCartInprogressModal = false;
              this.cd.detectChanges();
              setTimeout(() => {
                const hasError = sessionStorage.getItem('InsufficientStockError');

                if (hasError === null) {
                  if (this.pageType === 'PDP' && this?.nonBackorder?.length === undefined) {
                    this.showGlobalMessage(
                      'cart.addToCartSuccess',
                      GlobalMessageType.MSG_TYPE_CONFIRMATION,
                      productCode
                    );
                    cartStatus.unsubscribe();
                  }

                  if (this.pageType === 'quickorder') {
                    this.showGlobalMessage(
                      'cart.quickOrder.submitModal.success',
                      GlobalMessageType.MSG_TYPE_CONFIRMATION
                    );
                    cartStatus.unsubscribe();
                  }
                  this.closeModal(entry?.product?.code);
                } else {
                  this.closeModal('hasError');
                }

                sessionStorage.removeItem('InsufficientStockError');
                this.componentService.setMiniCartLoading(false);
                cartStatus.unsubscribe();
              }, 1000);
            }
            this.componentService.productCodeJustAddedToCart$.next(null);
          });
        },
        (err) => {
          this.componentService.setMiniCartLoading(false);
          this.cd.detectChanges();
          this.messageService.add({ key: 'cart.quickOrder.submitModal.error' }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      )
      .unsubscribe();
  }
  private showGlobalMessage(text: string, messageType: GlobalMessageType, param?: string) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  ngOnDestroy(): void {
    if (this.saveCartDetailsFormModelSubscription$) {
      this.saveCartDetailsFormModelSubscription$.unsubscribe();
    }
    if (this.saveCartDetailsFormGroupSubscription$) {
      this.saveCartDetailsFormGroupSubscription$.unsubscribe();
    }
  }
}
